import { Status } from 'src/constants';

import { getPlanDate } from '../PaperPlans/PaperPlanUtils';
import { convertDateStringToDateObj } from '../dateTimeUtil';

export const getGeneralStatus = (object: any, isPaperPlan = false) => {
    let startDate, endDate;

    if (isPaperPlan) {
        startDate = object.startDate ? convertDateStringToDateObj(getPlanDate(object.startDate)) : object.startDate;
        endDate = object.endDate ? convertDateStringToDateObj(getPlanDate(object.endDate, true)) : object.endDate;
    } else {
        startDate = typeof object.startDate === 'string' ? new Date(object.startDate) : object.startDate;
        endDate = typeof object.endDate === 'string' ? new Date(object.endDate) : object.endDate;
    }

    if (object.isDeleted) return Status.Canceled;
    if (object.isDraft) return Status.Draft;
    if (!Number.isNaN(startDate.getDate()) && startDate > new Date()) {
        return Status.Upcoming;
    } else if (!endDate || Number.isNaN(endDate.getDate()) || endDate >= new Date()) {
        return Status.Active;
    } else if (endDate && endDate < new Date()) {
        return Status.Ended;
    } else {
        return Status.Active;
    }
};
